import { useState } from 'react';
import { FiDownload, FiX, FiSmartphone, FiCheck } from 'react-icons/fi';
import { usePWAInstall } from '../../lib/pwa';

export default function PWAInstallPrompt() {
  const { isInstallable, installPWA } = usePWAInstall();
  const [isVisible, setIsVisible] = useState(true);
  const [isInstalling, setIsInstalling] = useState(false);

  const handleInstall = async () => {
    setIsInstalling(true);
    const success = await installPWA();
    
    if (success) {
      setIsVisible(false);
    }
    
    setIsInstalling(false);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    // Store dismissal in localStorage to avoid showing again for a while
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  // Don't show if not installable or user previously dismissed
  if (!isInstallable || !isVisible) {
    return null;
  }

  // Check if user dismissed recently (within 7 days)
  const dismissedTime = localStorage.getItem('pwa-install-dismissed');
  if (dismissedTime) {
    const sevenDaysAgo = Date.now() - (7 * 24 * 60 * 60 * 1000);
    if (parseInt(dismissedTime) > sevenDaysAgo) {
      return null;
    }
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-wine rounded-lg flex items-center justify-center mr-3">
              <FiSmartphone className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">Install TopDial</h3>
              <p className="text-sm text-gray-600">Get the app experience</p>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 p-1"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>

        <div className="space-y-2 mb-4">
          <div className="flex items-center text-sm text-gray-600">
            <FiCheck className="h-4 w-4 text-green-500 mr-2" />
            Faster loading & offline access
          </div>
          <div className="flex items-center text-sm text-gray-600">
            <FiCheck className="h-4 w-4 text-green-500 mr-2" />
            Push notifications for new properties
          </div>
          <div className="flex items-center text-sm text-gray-600">
            <FiCheck className="h-4 w-4 text-green-500 mr-2" />
            App-like experience
          </div>
        </div>

        <div className="flex space-x-2">
          <button
            onClick={handleInstall}
            disabled={isInstalling}
            className="flex-1 bg-wine text-white px-4 py-2 rounded-lg font-medium hover:bg-wine-dark transition-colors disabled:opacity-50 flex items-center justify-center"
          >
            {isInstalling ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
                Installing...
              </>
            ) : (
              <>
                <FiDownload className="h-4 w-4 mr-2" />
                Install
              </>
            )}
          </button>
          <button
            onClick={handleDismiss}
            className="px-4 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
